import { render, staticRenderFns } from "./PublicationReportsPage.vue?vue&type=template&id=bbc07400&"
import script from "./PublicationReportsPage.vue?vue&type=script&lang=js&"
export * from "./PublicationReportsPage.vue?vue&type=script&lang=js&"
import style0 from "./PublicationReportsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports